import React, { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import BootstrapTable from "react-bootstrap-table-next";
import ToolkitProvider from "react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min";
import paginationFactory from "react-bootstrap-table2-paginator";

const NotFound = () => {
  return (
    <div className="content-wrapper">
      <section class="content-header">
        <div class="container-fluid">
          <div class="row mb-2">
            <div class="col-sm-6">
              <h1>404 Error Page</h1>
            </div>
            <div class="col-sm-6">
              <ol class="breadcrumb float-sm-right">
                <li class="breadcrumb-item">
                  <a href="#">Home</a>
                </li>
                <li class="breadcrumb-item active">404 Error Page</li>
              </ol>
            </div>
          </div>
        </div>
        <section class="content">
          <div class="error-page">
            <h2 class="headline text-warning"> 404</h2>

            <div class="error-content">
              <h3>
                <i class="fas fa-exclamation-triangle text-warning"></i> Oops!
                Page not found.
              </h3>

              <p>
                We could not find the page you were looking for. Meanwhile, you
                may <a href="../../index.html">return to dashboard</a> or try
                using the search form.
              </p>

              <form class="search-form">
                <div class="input-group">
                  <input
                    type="text"
                    name="search"
                    class="form-control"
                    placeholder="Search"
                  />

                  <div class="input-group-append">
                    <button type="submit" name="submit" class="btn btn-warning">
                      <i class="fas fa-search"></i>
                    </button>
                  </div>
                </div>
              </form>
            </div>
          </div>
        </section>
      </section>
    </div>
  );
};
export default NotFound;
